import { render, staticRenderFns } from "./doc8.vue?vue&type=template&id=71a28702"
import script from "./doc8.vue?vue&type=script&lang=js"
export * from "./doc8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports